import React from "react";
import { comparisonRows, proIncludes } from "../../data/megapack";
import { E } from "../Emoji";
export function ComparisonSection() {
  return <section aria-labelledby="pro" className="bg-abyss" data-id="element-86" data-mp="izcjb277l2wi">
      <div className="mx-auto max-w-2xl px-5 py-14" data-id="element-87" data-mp="515usco5gf9i">
        <h2 id="pro" className="text-center text-3xl font-black leading-tight text-white" data-id="element-88" data-mp="52qq44iag28f">
          <E data-id="element-89" data-mp="a1k3zy1hlv94">🏆</E> ¿QUÉ AGREGA EL <span className="text-bright" data-id="element-90" data-mp="3rg7f5xpl9n13">MEGAPACK PRO</span>?
        </h2>

        <div className="mt-7 overflow-hidden rounded-2xl border border-line/50 bg-night" data-id="element-91" data-mp="3rdup0x9og6cy">
          <div className="space-y-3 bg-navy py-4 text-center font-black" data-id="element-92" data-mp="2kvcfgq1zm4">
            <p className="text-white" data-id="element-93" data-mp="3igkbf59e054v"><E data-id="element-94" data-mp="3ih3s6inawnhb">❌ Sin el PRO</E></p>
            <p className="text-bright" data-id="element-95" data-mp="3ne406z3po0b2"><E data-id="element-96" data-mp="3nff4r14zdc38">✅ Con el PRO</E></p>
          </div>
          <ul className="divide-y divide-line/30" data-id="element-97" data-mp="3nbzmxqjx9oy4">
            {comparisonRows.map(r => <li key={r.situation} className="space-y-2.5 p-4 text-sm" data-id="element-98" data-mp="38j653yh6gwqa">
                <p data-id="element-99" data-mp="3dfo9uycicv2m">
                  <span className="block font-bold text-mute" data-id="element-100" data-mp="3diaeap43qugm">Situación:</span>
                  <span className="font-black text-white" data-id="element-101" data-mp="z663h8njp4wi">{r.situation}</span>
                </p>
                <p data-id="element-102" data-mp="u84jmliap1jz">
                  <span className="block font-bold text-mute" data-id="element-103" data-mp="uaqpmgpjf903"><E data-id="element-104" data-mp="188xdr54opumk">❌ Sin el PRO:</E></span>
                  <span className="text-white/80" data-id="element-105" data-mp="187mcpd2mj0z5">{r.without}</span>
                </p>
                <p data-id="element-106" data-mp="147bxrawut085">
                  <span className="block font-bold text-bright" data-id="element-107" data-mp="144pon6ubecnt"><E data-id="element-108" data-mp="ggg9gnrlwn5n">✅ Con el PRO:</E></span>
                  <span className="font-black text-white" data-id="element-109" data-mp="ghhkis8mh9nd">{r.withPro}</span>
                </p>
              </li>)}
          </ul>
        </div>

        <h3 className="mt-10 text-center text-2xl font-black text-white" data-id="element-110" data-mp="p9t9sas02r1r">
          <E data-id="element-111" data-mp="kiup6yzzb6sp">✅ EL PRO INCLUYE:</E>
        </h3>
        <ul className="mt-5 flex flex-col items-center gap-2.5" data-id="element-112" data-mp="ki1jm1cranc5">
          {proIncludes.map(i => <li key={i} className="rounded-full bg-night px-5 py-2 text-sm font-black text-white" data-id="element-113" data-mp="3sx3dhuvgxbf2">
              {i}
            </li>)}
        </ul>
      </div>
    </section>;
}